module.exports = __webpack_public_path__ + "static/media/19-MoneyCompass.c3ca22be.png";